// extracted by mini-css-extract-plugin
export var section = "styles-module--section--2OaOm";
export var extraSpace = "styles-module--extraSpace--2UnZV";
export var textContainer = "styles-module--textContainer--2386j";
export var title = "styles-module--title--3ZeL5";
export var content = "styles-module--content--3AyuD";